<template>
  <div>
    <b-modal ref="modalDocumentAliasName" hide-footer title="Re-name document">
      <div class="d-block">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder=" "
                autocomplete="off_aliasName"
                v-model="aliasName"
              />
              <label class="floatingLabel" for="aliasName">File name</label>
              <div class="invalid-feedback" v-if="errors.aliasName">
                {{ errors.aliasName[0] }}
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="text-right">
          <button
            type="button"
            class="btn btn-dark btn-sm mr-2"
            @click="fnHideModal"
          >
            Cancel
          </button>
          <button
            type="button"
            @click="fnUpdateFileName()"
            class="btn btn-primary btn-sm"
          >
            <b-spinner small v-if="is_spinActive"></b-spinner>
            Save
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as messageService from '../../services/message.service'
import * as clientDocumentService from '../../services/clientDocument.service'
import * as leadsService from '../../services/leads.service'

export default {
  name: 'ModalDocumentAliasName',
  props: ['quoteId', 'documentId', 'quoteType'],
  components: {},
  data() {
    return {
      errors: {},
      is_spinActive: false,
      aliasName: ''
    }
  },
  computed: {
    ...mapGetters(['getQuoteSingle'])
  },
  methods: {
    ...mapActions(['fetchQuoteSingle']),
    fnShowModal() {
      this.aliasName = ''
      this.$refs.modalDocumentAliasName.show()
    },
    fnHideModal() {
      this.$refs.modalDocumentAliasName.hide()
    },

    fnUpdateFileName: async function () {
      try {
        this.is_spinActive = true
        let obj = {
          aliasName: this.aliasName
        }

        if (this.quoteType == 'quote') {
          const response =
            await clientDocumentService.documentAddOrUpdateAliasName(
              this.documentId,
              obj
            )
        }

        if (this.quoteType == 'leads') {
          const response = await leadsService.documentAddOrUpdateAliasName(
            this.documentId,
            obj
          )
        }

        this.fetchQuoteSingle({ id: this.quoteId, quoteType: this.quoteType })

        this.is_spinActive = false
        this.fnHideModal()
        messageService.fnSweetAlertSuccessToast(
          'Re-name file',
          'Saved successfully'
        )
      } catch (error) {
        console.log('hellow', error)
      }
    }
  },

  watch: {}
}
</script>
